// extracted by mini-css-extract-plugin
export default {"player":"Player_player__BbU5W","form":"Player_form__ylewW","input":"Player_input__2bsk6","button":"Player_button__674Te"};